import { render, staticRenderFns } from "./desctext.vue?vue&type=template&id=f10e18c4&scoped=true&"
import script from "./desctext.vue?vue&type=script&lang=js&"
export * from "./desctext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10e18c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f10e18c4')) {
      api.createRecord('f10e18c4', component.options)
    } else {
      api.reload('f10e18c4', component.options)
    }
    module.hot.accept("./desctext.vue?vue&type=template&id=f10e18c4&scoped=true&", function () {
      api.rerender('f10e18c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormDesign/ItemConfig/desctext.vue"
export default component.exports